import { render, staticRenderFns } from "./ActiveLives.vue?vue&type=template&id=13a70036&"
import script from "./ActiveLives.vue?vue&type=script&lang=js&"
export * from "./ActiveLives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports